module.exports = __webpack_public_path__ + "img/time-badge-gold.949e483f.svg";